function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import React from 'react';
export var freeTablePagination = {
  defaultPageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: function showTotal(total, range) {
    return "\u5171 ".concat(total, " \u6761\u8BB0\u5F55");
  },
  defaultCurrent: 1,
  size: 'default'
};
export var freeTableSearchButton = function freeTableSearchButton(doms) {
  var isSingle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return doms.map(function (dom, index) {
    var isSearch = index === 1;
    if (isSingle && !isSearch) {
      return null;
    }
    return /*#__PURE__*/React.cloneElement(dom, {
      type: isSearch ? 'primary' : 'default',
      ghost: !!isSearch,
      icon: isSearch ? /*#__PURE__*/React.createElement(SearchOutlined, null) : /*#__PURE__*/React.createElement(ReloadOutlined, null),
      className: isSearch ? 'search-button' : "reload-button"
    });
  });
};
export var freeTableSearch = {
  defaultCollapsed: true,
  labelWidth: 'auto',
  optionRender: function optionRender(searchConfig, formProps, dom) {
    return _toConsumableArray(freeTableSearchButton(dom));
  }
};
export var getFreeTableSearch = function getFreeTableSearch(isSingle) {
  return {
    defaultCollapsed: true,
    labelWidth: 'auto',
    optionRender: function optionRender(searchConfig, formProps, dom) {
      return _toConsumableArray(freeTableSearchButton(dom, isSingle));
    },
    className: "".concat(isSingle ? 'search-panel-single' : '')
  };
};